import { render, staticRenderFns } from "./InvoiceTabs.vue?vue&type=template&id=2d6ca9e9"
import script from "./InvoiceTabs.vue?vue&type=script&lang=ts"
export * from "./InvoiceTabs.vue?vue&type=script&lang=ts"
import style0 from "./InvoiceTabs.vue?vue&type=style&index=0&id=2d6ca9e9&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d6ca9e9')) {
      api.createRecord('2d6ca9e9', component.options)
    } else {
      api.reload('2d6ca9e9', component.options)
    }
    module.hot.accept("./InvoiceTabs.vue?vue&type=template&id=2d6ca9e9", function () {
      api.rerender('2d6ca9e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/invoice/InvoiceTabs.vue"
export default component.exports